import {useInfiniteQuery} from '@tanstack/react-query';
import {getRestaurants} from 'api/requests';
import {Restaurants} from 'components/pages/restaurants';
import {Section} from 'components/shared';
import {useDesktop, useTranslation} from 'hooks';
import {FC} from 'react';
import {ICustomerAddToFavoritesRequest, ICustomerMyFavoritesResponse, QueryKeyEnum} from 'types';

interface IProps {
  locale: string;
  myFavorite: ICustomerMyFavoritesResponse[];
  onEditFavorite: (data: ICustomerAddToFavoritesRequest) => void;
  coordinates: string;
  disableCount: boolean;
}

export const RestaurantsSection: FC<IProps> = ({locale, myFavorite, onEditFavorite, coordinates, disableCount}) => {
  const {t} = useTranslation();
  const isDesktop = useDesktop();
  const {
    data: restaurantData,
    isLoading: isLoadingRestaurants,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    [QueryKeyEnum.RESTAURANTS, locale, coordinates],
    ({pageParam = 0}) =>
      getRestaurants({
        offset: pageParam,
        limit: 32,
        ordering: 'distance',
      }),
    {
      staleTime: 0,
      getNextPageParam: (lastPage) => {
        if (lastPage?.next && typeof lastPage?.next === 'string') {
          return parseInt(lastPage.next.split('offset=')[1]);
        }
        return null;
      },
    },
  );

  const isShowBlock = !!restaurantData?.pages[0].results.length || isLoadingRestaurants;

  return (
    <>
      {isShowBlock && (
        <Section
          title={t('RESTAURANTS_TITLE')}
          linkTo="/restaurants?ordering=distance"
          viewAllLabel={t('VIEW_ALL')}
          count="200+"
          borderBottomRadius="16px"
          disableCount={disableCount}
        >
          <Restaurants
            restaurantData={restaurantData}
            isLoadingRestaurants={isLoadingRestaurants}
            hasNextPage={hasNextPage}
            fetchNextPage={fetchNextPage}
            isFetchingNextPage={isFetchingNextPage}
            isDesktop={isDesktop}
            myFavorite={myFavorite}
            onEditFavorites={onEditFavorite}
            t={t}
          />
        </Section>
      )}
    </>
  );
};
